// extracted by mini-css-extract-plugin
export default {"form":"ContactForm_form__aAvy+","label":"ContactForm_label__cXPoX","input":"ContactForm_input__C8ULr","button":"ContactForm_button__nSwOK"};